import { all } from "redux-saga/effects";
import { authSaga } from "./auth/authSaga";
import categorySagaWrapper from "./category/categorySaga";
import cauHoiSagaWrapper from "./cau-hoi/cauHoiSagaWrapper";
import quyetDinhSagaWrapper from "./quyet-dinh/quyetDinhSagaWrapper";
import deThiSagaWrapper from "./de-thi/deThiSagaWrapper";

export default function* rootSaga() {
  yield all([
    authSaga(),
    categorySagaWrapper(),
    cauHoiSagaWrapper(),
    quyetDinhSagaWrapper(),
    deThiSagaWrapper(),
  ]);
}
